module.exports = __webpack_public_path__ + "static/media/shop-vip-divider.ecc3c5fa.png";